<template>

   <li  @click="DesplegarTarget(subitem)" class="list-group-item carSend" style="display: grid;align-items: center;grid-template-columns: 79px 1fr 36px;font-size: 13px;padding-left: 10px;padding-right: 17px;">             
                  <span >{{subitem.dfechacarga.substring(0,10)}} </span>
                 <!--   <span style="text-align: center;"> Factura : {{subitem.vfactura}}</span> -->
                    <span style="text-align: right;">{{subitem.puntaje}} </span>
                    <div v-for="(item,index) in detalle" :key="index" :class="{'changeNew':subitem.puntaje > 0}" class="gridTemplate" v-show="changeState" > 
                       <span style="text-align: left;grid-column: span 2;">{{item.sDescripcion}}</span>
                       <span style="padding-left: 0px;grid-column: span 2 / auto;text-align: left;">{{item.sMaterial}}</span>
                       <span style="padding-left: 0px;grid-column: span 2 / auto;text-align: left;">{{item.vValor}}</span>
                       <span style="    grid-column: span 2 / auto;text-align: end;margin-right: 13px;position: absolute;right: 0px;
    top: 37%;">{{item.puntaje}}</span>
                </div>
        </li>

</template>
<script>

export default {

props:['subitem'],
  data: function () {
    return {   
        changeState:false,
        detalle:[]


    };
  },
  methods:{
  DesplegarTarget(subitem){


   let backend = this.$store.state.backend;
   this.axios
   .get(backend+`/api/Puntos/ConsultaDetallePuntos?nid=${subitem.nid}&vFactura=${subitem.vfactura}`, {

         headers:{
            Authorization: "Bearer " + localStorage.token,      
        },
   })
   .then((response)=>{

      this.detalle = response.data.olDet


   })
    .catch((error) => {
          error.handleGlobally && error.handleGlobally();
        });

      this.changeState = !this.changeState
    },



  }
}

</script>
<style>
.changeNew{
background-color: rgb(132 96 165) !important;}
.gridTemplate{
    grid-column: span 3;
    background: rgb(131 182 237);
        color: white;
    padding-left: 9px;
    padding-top: 3px;
    padding-bottom: 3px;
    border-radius: 3px 3px 3px 3px;
    display: grid;
    grid-template-columns: 3fr 1fr;
    grid-template-rows: repeat(3,15px);
    position:relative;
    margin-bottom: 8px;
    font-size: 10px;
}
</style>